import React, {Component} from 'react';
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Input
} from 'reactstrap';
import {Link} from 'react-router-dom';

class Paging extends Component {
  constructor(props) {
    super(props);
  }

  renderPaginationItem() {
    let options = [];

    for (let i = 1; i <= this.props.maxPage; i++) {
      options.push(<option key={i} value={i}>{i}</option>);
    }
    return (
      <PaginationItem>
        <Input
            type="select"
            value={this.props.currentPage}
            onChange={(e) => { this.handlePageChange(e.target.value) }} >
            {options}
        </Input>
      </PaginationItem>
    );
  }

  handlePageChange(page) {
    this.props.onChangePage(page);
  }

  render() {
    return (
      <Pagination>
        <PaginationItem disabled={this.props.currentPage <= 1} >
          <PaginationLink
            previous
            onClick={() => { this.handlePageChange((this.props.currentPage - 1)) }} >Prev</PaginationLink>
        </PaginationItem>
        {this.renderPaginationItem()}
        <PaginationItem disabled={this.props.currentPage >= this.props.maxPage}>
          <PaginationLink
            next
            onClick={() => { this.handlePageChange((this.props.currentPage + 1)) }} >Next</PaginationLink>
        </PaginationItem>
      </Pagination>
    )
  }
}

Paging.defaultProps = {
  currentPage: 0,
  maxPage: 0,
  url: ""
};

export default Paging;



// WEBPACK FOOTER //
// ./src/components/Grid/Paging.js